// Shared scroll-preservation helper for list controllers.
//
// The native editor scrolls inside `.en-main` (overflow-y: auto), not the
// window. When a controller rebuilds its list via `innerHTML = …`, the
// browser can snap that scroll container back to the top. These helpers
// capture the scroll offset around a re-render and restore it, so editing
// a list never yanks the editor pane.
//
// This file is auto-pinned by `pin_all_from "app/javascript/controllers"`;
// it is NOT a `*_controller.js`, so importmap exposes it as a module but
// Stimulus does not register it as a controller.

// Nearest scrollable ancestor of `el` — the element whose scrollTop we
// must preserve. Walks up looking for a computed overflow-y of
// auto/scroll/overlay that actually overflows; falls back to the document
// scrolling element.
export function findScrollParent(el) {
  let p = el?.parentElement
  while (p && p !== document.body) {
    const cs = getComputedStyle(p)
    const oy = cs.overflowY
    if ((oy === "auto" || oy === "scroll" || oy === "overlay") && p.scrollHeight > p.clientHeight) {
      return p
    }
    p = p.parentElement
  }
  return document.scrollingElement || document.documentElement
}

// Run `renderFn` (a full re-render) while holding the scroll position of
// `el`'s scroll parent steady.
export function preserveScroll(el, renderFn) {
  const scroller = findScrollParent(el)
  const top  = scroller ? scroller.scrollTop  : 0
  const left = scroller ? scroller.scrollLeft : 0
  renderFn()
  if (scroller) {
    scroller.scrollTop  = top
    scroller.scrollLeft = left
  }
}
